import React, { useEffect } from "react";
import {
  BrowserRouter,
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import ReactDOM from "react-dom";

import { NavLink, Link } from "react-router-dom";
import $ from "jquery";
import {
  BadgeInfo,
  BanknoteArrowUp,
  BarChart,
  BarChart2,
  BookDashed,
  Cake,
  ChartCandlestick,
  CheckSquare,
  Coins,
  CreditCard,
  DollarSign,
  FileCheck,
  FileVideoCamera,
  FolderOpen,
  HandFist,
  Key,
  LayoutDashboard,
  LibraryBig,
  Mail,
  Mailbox,
  MailCheck,
  MailOpen,
  MailQuestionMark,
  Mails,
  MailWarning,
  MailX,
  MapPinPlus,
  MessageCircle,
  NotebookPen,
  RadioTower,
  SquareActivity,
  Store,
  Sword,
  Swords,
  Ticket,
  UserRoundPen,
  UserRoundPlus,
  Users,
  UsersRound,
  UserX,
  Wallet,
  Waypoints,
  XSquare,
  Phone,
  MessageSquareHeart,
  Vote,
  Zap,
} from "lucide-react";
import { IoIosPhonePortrait } from "react-icons/io";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { FaChartArea, FaImage } from "react-icons/fa";

// import profile from "../../../images/profile.jpg";
import logo from "../../../images/homepage/logoNew.svg";
import miniLogo from "../../../images/homepage/miniLogo.svg";
import api from "../../../api";
import { useSelector } from "react-redux";
import { MailLockOutlined } from "@mui/icons-material";

function Sidebar({ adminType, permissions }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const location = useLocation();

  // useEffect(()=>{
  //   sidebarFunctionality()
  // })

  //   const sidebarFunctionality=()=>{
  //     /* eslint-disable */
  //       "use strict";
  //       $("#sidebarToggle, #sidebarToggleTop").on("click", function (e) {
  //           $("body").toggleClass("sidebar-toggled"), $(".sidebar").toggleClass("toggled"), $(".sidebar").hasClass("toggled") && $(".sidebar .collapse").collapse("hide");
  //       }),
  //       $(window).resize(function () {
  //         $(window).width() < 768 && $(".sidebar .collapse").collapse("hide"),
  //         $(window).width() < 480 && !$(".sidebar").hasClass("toggled") && ($("body").addClass("sidebar-toggled"), $(".sidebar").addClass("toggled"), $(".sidebar .collapse").collapse("hide"));
  //           }),
  //           $("body.fixed-nav .sidebar").on("mousewheel DOMMouseScroll wheel", function (e) {
  //               var o;
  //               768 < $(window).width() && ((o = (o = e.originalEvent).wheelDelta || -o.detail), (this.scrollTop += 30 * (o < 0 ? 1 : -1)), e.preventDefault());
  //           }),
  //           $(document).on("scroll", function () {
  //               100 < $(this).scrollTop() ? $(".scroll-to-top").fadeIn() : $(".scroll-to-top").fadeOut();
  //           });

  //   }

  const setOnlineStatus = async () => {
    const res = await api.editSupportStatus();
  };

  useEffect(() => {
    if (adminType === "sackAdmin755") {
      // Send immediately on load
      setOnlineStatus();

      // Then send every 30 seconds
      const interval = setInterval(() => {
        setOnlineStatus();
      }, 30000);

      return () => clearInterval(interval);
    }
  }, [adminType]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const handleLinkClick = () => {
      if (window.innerWidth < 768) {
        document.body.classList.remove("sidebar-mobile-open");
        const openCollapse = document.querySelector(".collapse.show");
        if (openCollapse) {
          openCollapse.classList.remove("show");

          const trigger = document.querySelector(
            `[data-bs-target="#${openCollapse.id}"]`,
          );
          if (trigger) {
            trigger.classList.add("collapsed");
            trigger.setAttribute("aria-expanded", "false");
          }
        }
      }
    };

    const handleOutsideClick = (event) => {
      if (window.innerWidth < 768) {
        const openCollapse = document.querySelector(".collapse.show");
        if (
          openCollapse &&
          !openCollapse.contains(event.target) && // clicked outside dropdown body
          !event.target.closest("[data-bs-toggle='collapse']") // not the toggle link
        ) {
          openCollapse.classList.remove("show");

          const trigger = document.querySelector(
            `[data-bs-target="#${openCollapse.id}"]`,
          );
          if (trigger) {
            trigger.classList.add("collapsed");
            trigger.setAttribute("aria-expanded", "false");
          }
        }
      }
    };

    // attach events
    const links = document.querySelectorAll(".collapse-inner .nav-link, .sidebar-Link");
    links.forEach((link) => link.addEventListener("click", handleLinkClick));
    document.addEventListener("click", handleOutsideClick);

    // cleanup
    return () => {
      links.forEach((link) =>
        link.removeEventListener("click", handleLinkClick),
      );
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const closeMobileSidebar = () => {
    document.body.classList.remove("sidebar-mobile-open");
  };

  return (
    <>
      {/* Mobile overlay — tap to close sidebar */}
      <div className="sidebar-mobile-overlay d-md-none" onClick={closeMobileSidebar} />

      {/* Sidebar */}
      <ul
        className="navbar-nav shadow sidebar sidebar-dark accordion zi-1 pb-100"
        id="accordionSidebar"
      >
        {/* Sidebar - Brand */}
        <Link
          className="sidebar-brand d-flex align-items-center justify-content-center mt-2"
          to="/"
        >
          <div className="sidebar-brand-text mx-3">
            <img src={logo} className="w-100" alt="waqazaka.net" />
          </div>
          <div className="mini">
            <img src={miniLogo} className="w-100" alt="waqazaka.net" />
          </div>
        </Link>
        {adminType == "sackAdmin755" && (
          <>
            <li className="nav-item my-1 mt-4">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/support/dataInfo"
                end
              >
                {/* <img className="" src={home} alt="" /> */}
                <BadgeInfo size={20} /> <span className="">Data Info</span>
              </NavLink>
            </li>
            <li className="nav-item my-1 ">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/users"
              >
                {/* <img className="" src={home} alt="" /> */}
                <Users size={20} />
                <span className="">Users</span>
              </NavLink>
            </li>
            <li className="nav-item my-1">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/paid-users"
              >
                {/* <img className="" src={home} alt="" /> */}
                <BanknoteArrowUp size={20} />{" "}
                <span className="">Paid Users</span>
              </NavLink>
            </li>
            <li className="nav-item my-1">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/support"
                end
              >
                {/* <img className="" src={home} alt="" /> */}
                <Ticket size={20} />
                <span className="">Support Ticket</span>
              </NavLink>
            </li>
            <li className="nav-item my-1">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/get/support"
                end
              >
                <UsersRound size={20} />
                <span className="">Support Member Details</span>
              </NavLink>
            </li>
          </>
        )}
        {/* sidebar links */}

        {adminType == "mackAdmin777" &&
          adminStore?.admin?.admin?.email == "stats@waqarzaka.net" && (
            <>
              <li className="nav-item my-1 mt-5">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/waqarzaka/stats"
                >
                  {/* <img className="" src={home} alt="" /> */}
                  <span className="">Overview</span>
                </NavLink>
              </li>
              <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/waqarzaka/yubit-referrals"
                >
                  <span className="">Yubit Referrals</span>
                </NavLink>
              </li>
            </>
          )}

        {adminType == "mackAdmin777" &&
          adminStore?.admin?.admin?.email != "stats@waqarzaka.net" && (
            <>
              <li className="nav-item my-1 mt-5">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/datainfo"
                >
                  {/* <img className="" src={home} alt="" /> */}
                  <BadgeInfo size={20} /> <span className="">Data Info</span>
                </NavLink>
              </li>
              <li className="nav-item my-1">
                <a
                  className="nav-link jc-sb collapsed"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseMobile"
                  aria-expanded="true"
                  aria-controls="collapseMobile"
                >
                  <div
                    className="sidebar-dd-label"
                  >
                    <IoIosPhonePortrait size={20} /> <span>Mobile App</span>
                  </div>
                  <i className="fa-solid fa-chevron-down"></i>
                </a>
                <div
                  id="collapseMobile"
                  className="collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/mobile/banner"
                    >
                      <FaImage size={20} />{" "}
                      <span className="ms-3">Home Banner</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/mobile/push-notification"
                    >
                      <MdOutlineNotificationsActive size={20} />{" "}
                      <span className="ms-3">Push Notification</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/mobile/notice"
                    >
                      <MdOutlineNotificationsActive size={20} />{" "}
                      <span className="ms-3">Notice Modal</span>
                    </NavLink>
                  </div>
                </div>
              </li>
              <li className="nav-item my-1">
                <a
                  className="nav-link jc-sb collapsed"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="true"
                  aria-controls="collapseTwo"
                >
                  <div
                    className="sidebar-dd-label"
                  >
                    <HandFist size={20} />
                    <span>Support</span>
                  </div>
                  {/* <span><HandFist size={20} /> Support</span> */}
                  <i className="fa-solid fa-chevron-down"></i>
                </a>
                <div
                  id="collapseTwo"
                  className="collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <NavLink
                      className="nav-link sidebar-Link fw-500 "
                      to="/admin/all-admins"
                    >
                      <UsersRound size={20} />
                      <span className="ms-3">Support Members</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/support"
                      end
                    >
                      <Ticket size={20} />{" "}
                      <span className="ms-3">Support Ticket</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/support-activity"
                      end
                    >
                      <SquareActivity size={20} />{" "}
                      <span className="ms-3">Support Activity</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/ticket-feedback"
                      end
                    >
                      <MessageSquareHeart size={20} />{" "}
                      <span className="ms-3">Ticket Feedback</span>
                    </NavLink>
                  </div>
                </div>
              </li>

              <li className="nav-item my-1">
                <a
                  className="nav-link jc-sb collapsed"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse3"
                  aria-expanded="true"
                  aria-controls="collapse3"
                >
                  <div
                    className="sidebar-dd-label"
                  >
                    <BarChart size={20} /> <span>Summary</span>
                  </div>
                  <i className="fa-solid fa-chevron-down"></i>
                </a>
                <div
                  id="collapse3"
                  className="collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/create-trade-summary"
                    >
                      <MapPinPlus size={20} />{" "}
                      <span className="ms-3">Create Trade Summary</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/trade-summary"
                    >
                      <ChartCandlestick size={20} />{" "}
                      <span className="ms-3">Trade Summary</span>
                    </NavLink>
                  </div>
                </div>
              </li>

              <li className="nav-item my-1">
                <a
                  className="nav-link jc-sb collapsed"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse4"
                  aria-expanded="true"
                  aria-controls="collapse4"
                >
                  <div
                    className="sidebar-dd-label"
                  >
                    <Users size={20} />
                    <span>Users</span>
                  </div>
                  <i className="fa-solid fa-chevron-down"></i>
                </a>
                <div
                  id="collapse4"
                  className="collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/users"
                    >
                      <UsersRound size={20} />{" "}
                      <span className="ms-3">Users</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/duplicate-users"
                    >
                      <UserRoundPlus size={20} />{" "}
                      <span className="ms-3">Duplicate Users</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/wallet-users"
                    >
                      <Wallet size={20} />{" "}
                      <span className="ms-3">Wallet Users</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/paid-users"
                    >
                      <BanknoteArrowUp size={20} />{" "}
                      <span className="ms-3">Paid Users</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/unsubscribed-users"
                    >
                      <UserX size={20} />{" "}
                      <span className="ms-3">Unsubscribed Users</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/direct-paid-users"
                    >
                      <BanknoteArrowUp size={20} />{" "}
                      <span className="ms-3">Direct Subscriptions</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/user-paid-by-admin"
                    >
                      <BanknoteArrowUp size={20} />{" "}
                      <span className="ms-3">UserPaidByAdmin</span>
                    </NavLink>
                  </div>
                </div>
              </li>

              {/* <li className="nav-item my-1">
                <a
                  className="nav-link jc-sb collapsed"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse7"
                  aria-expanded="true"
                  aria-controls="collapse7"
                >
                  <div
                    className="sidebar-dd-label"
                  >
                    <Sword size={20} />
                    <span>Challenge</span>
                  </div>
                  <i className="fa-solid fa-chevron-down"></i>
                </a>
                <div
                  id="collapse7"
                  className="collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/challenge-plans"
                    >
                      <Waypoints size={20} />{" "}
                      <span className="ms-3">Challenge Plan</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/challenges"
                    >
                      <Swords size={20} />{" "}
                      <span className="ms-3">Challenges</span>
                    </NavLink>
                  </div>
                </div>
              </li> */}
            </>
          )}
        {/* <li className="nav-item my-1">
              <NavLink className="nav-link sidebar-Link fw-500" to="/admin/survey">
                <span className="">Survey</span></NavLink>
            </li> */}

        {adminStore?.admin?.admin?.email != "stats@waqarzaka.net" && (
          <>
            {(adminType == "jackAdmin775" ||
              adminType == "mackAdmin777" ||
              adminType == "sackAdmin755") && (
              <li className="nav-item my-1">
                <a
                  className="nav-link jc-sb collapsed"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse5"
                  aria-expanded="true"
                  aria-controls="collapse5"
                >
                  <div
                    className="sidebar-dd-label"
                  >
                    <LayoutDashboard size={20} />
                    <span>Dashboard</span>
                  </div>
                  <i className="fa-solid fa-chevron-down"></i>
                </a>
                <div
                  id="collapse5"
                  className="collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    {(adminType == "jackAdmin775" ||
                      adminType == "mackAdmin777" ||
                      permissions?.includes("crypto")) && (
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/signals"
                      >
                        {/* <img className="" src={home} alt="" /> */}
                        <Coins size={20} />{" "}
                        <span className="ms-3">Crypto Trades</span>
                      </NavLink>
                    )}
                    {(adminType == "jackAdmin775" ||
                      adminType == "mackAdmin777" ||
                      permissions?.includes("stock")) && (
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/stocks"
                      >
                        <ChartCandlestick size={20} />{" "}
                        <span className="ms-3">Stock & Commodities</span>
                      </NavLink>
                    )}
                    {(adminType == "jackAdmin775" ||
                      adminType == "mackAdmin777" ||
                      permissions?.includes("market")) && (
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/market"
                      >
                        <Store size={20} />{" "}
                        <span className="ms-3">Market Updates</span>
                      </NavLink>
                    )}
                    {(adminType == "jackAdmin775" ||
                      adminType == "mackAdmin777" ||
                      permissions?.includes("education")) && (
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/video"
                      >
                        <FileVideoCamera size={20} />{" "}
                        <span className="ms-3">ADD VIDEO IN EDUCATION</span>
                      </NavLink>
                    )}
                    {(adminType == "jackAdmin775" ||
                      adminType == "mackAdmin777" ||
                      permissions?.includes("live-session")) && (
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/live-session"
                      >
                        <RadioTower size={20} />{" "}
                        <span className="ms-3">Live Sessions</span>
                      </NavLink>
                    )}
                    {(adminType == "jackAdmin775" ||
                      adminType == "mackAdmin777" ||
                      permissions?.includes("live-session")) && (
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/live-session-trade"
                      >
                        <RadioTower size={20} />{" "}
                        <span className="ms-3">Live Session Trade</span>
                      </NavLink>
                    )}
                    {(adminType == "jackAdmin775" ||
                      adminType == "mackAdmin777" ||
                      permissions?.includes("live-session")) && (
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/future-trade"
                      >
                        <Zap size={20} />{" "}
                        <span className="ms-3">Future Trade</span>
                      </NavLink>
                    )}
                    {(adminType == "jackAdmin775" ||
                      adminType == "mackAdmin777" ||
                      permissions?.includes("trade-directory")) && (
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/trade-directory"
                      >
                        <FolderOpen size={20} />{" "}
                        <span className="ms-3">TRADE DIRECTORY</span>
                      </NavLink>
                    )}
                    {(adminType == "jackAdmin775" ||
                      adminType == "mackAdmin777" ||
                      permissions?.includes("godzilla")) && (
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/godzilla"
                      >
                        <ChartCandlestick size={20} />{" "}
                        <span className="ms-3">Godzilla Update</span>
                      </NavLink>
                    )}
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/general"
                    >
                      <ChartCandlestick size={20} />{" "}
                      <span className="ms-3">General</span>
                    </NavLink>
                  </div>
                </div>
              </li>
            )}

            {/* {(adminType == "jackAdmin775" ||
              adminType == "mackAdmin777" ||
              permissions?.includes("crypto")) && (
              <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/addpost"
                >
                  <span className="">Add Crypto Updates</span>
                </NavLink>
              </li>
            )} */}
            {/* {(adminType == "jackAdmin775" ||
              adminType == "mackAdmin777" ||
              permissions?.includes("education")) && (
              <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/video"
                >
                  <span className="">ADD VIDEO IN EDUCATION</span>
                </NavLink>
              </li>
            )} */}
          </>
        )}

        {/* <li className="nav-item my-1">
          <NavLink className="nav-link sidebar-Link fw-500" to="/admin/contact">
            <span className="">Contact Support</span>
          </NavLink>
        </li> */}

        {(adminType == "jackAdmin775" || adminType == "mackAdmin777") && (
          <>
            {adminStore?.admin?.admin?.email != "stats@waqarzaka.net" && (
              <>
                <li className="nav-item my-1">
                  <a
                    className="nav-link jc-sb collapsed"
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse6"
                    aria-expanded="true"
                    aria-controls="collapse6"
                  >
                    <div className="sidebar-dd-label">
                      <Mail size={20} />
                      <span>Send Email By Admin</span>
                    </div>
                    <i className="fa-solid fa-chevron-down"></i>
                  </a>
                  <div
                    id="collapse6"
                    className="collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionSidebar"
                  >
                    <div className="bg-white py-2 collapse-inner rounded">
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/sendmail"
                      >
                        {/* <img className="" src={home} alt="" /> */}
                        <Mailbox size={20} />{" "}
                        <span className="">Mail to Users</span>
                      </NavLink>
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/sendmail-paid-users"
                      >
                        {/* <img className="" src={home} alt="" /> */}
                        <MailCheck size={20} />{" "}
                        <span className="">Mail to Paid Users</span>
                      </NavLink>
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/sendmail-non-paid-users"
                      >
                        {/* <img className="" src={home} alt="" /> */}
                        <MailWarning size={20} />{" "}
                        <span className="">Mail to Non Paid Users</span>
                      </NavLink>
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/email-logs"
                      >
                        {/* <img className="" src={home} alt="" /> */}
                        <Mails size={20} /> <span className="">Email Logs</span>
                      </NavLink>
                    </div>
                  </div>
                </li>

                {/* <li className="nav-item my-1">
              <NavLink className="nav-link sidebar-Link fw-500" to="/admin/sendmail-tup-locker">
                <span className="">Mail to TUP Lockers</span></NavLink>
            </li> */}
                {/* <li className="nav-item my-1">
              <NavLink className="nav-link sidebar-Link fw-500" to="/admin/tup-locked">
                <span className="">TUP Locked List</span></NavLink>
            </li> */}
              </>
            )}
          </>
        )}
        {adminType == "jackAdmin775" && (
          <li className="nav-item my-1">
            <NavLink
              className="nav-link sidebar-Link fw-500"
              to="/admin/yearly-contact-form"
            >
              <span className="">YEARLY GROUP FORMS</span>
            </NavLink>
          </li>
        )}
        {adminType == "mackAdmin777" &&
          adminStore?.admin?.admin?.email != "stats@waqarzaka.net" && (
            <>
              <li className="nav-item my-1">
                <a
                  className="nav-link jc-sb collapsed"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse7"
                  aria-expanded="true"
                  aria-controls="collapse7"
                >
                  <div
                    className="sidebar-dd-label"
                  >
                    <LibraryBig size={20} />
                    <span>Search Data</span>
                  </div>
                  <i className="fa-solid fa-chevron-down"></i>
                </a>
                <div
                  id="collapse7"
                  className="collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/user-payment-history"
                    >
                      <DollarSign size={20} />{" "}
                      <span className="ms-3">Search Payment History</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/user-logs"
                    >
                      <UserRoundPen size={20} />{" "}
                      <span className="ms-3">Search User Logs</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/check-stripe-data"
                    >
                      <CreditCard size={20} />{" "}
                      <span className="ms-3">Search Stripe Details</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/check-godzilla"
                    >
                      <CreditCard size={20} />{" "}
                      <span className="ms-3">Search godzilla UID</span>
                    </NavLink>
                  </div>
                </div>
              </li>

              {/* <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/check-stripe-subscription"
                >
                  <span className="">SEARCH USER STRIPE</span>
                </NavLink>
              </li> */}
            </>
          )}
        {adminStore?.admin?.admin?.email != "stats@waqarzaka.net" &&
          adminType != "livetradestats" && (
            <>
              <li className="nav-item my-1">
                <a
                  className="nav-link jc-sb collapsed"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse8"
                  aria-expanded="true"
                  aria-controls="collapse8"
                >
                  <div
                    className="sidebar-dd-label"
                  >
                    <MailOpen size={20} />
                    <span>Send Email</span>
                  </div>
                  <i className="fa-solid fa-chevron-down"></i>
                </a>
                <div
                  id="collapse8"
                  className="collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/forget-pass"
                    >
                      <MailQuestionMark size={30} />{" "}
                      <span className="ms-3">USER FORGET PASSWORD EMAIL </span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/send-mail-paid"
                    >
                      <MailCheck size={20} />{" "}
                      <span className="ms-3">SEND WELCOME EMAIL</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/send-mail-otp"
                    >
                      <MailLockOutlined size={20} />{" "}
                      <span className="ms-3">SEND OTP EMAIL</span>
                    </NavLink>
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/send-mail-custom"
                    >
                      <NotebookPen size={20} />{" "}
                      <span className="ms-3">SEND CUSTOM EMAIL</span>
                    </NavLink>
                    {((adminType == "mackAdmin777" &&
                      adminStore?.admin?.admin?.email !=
                        "stats@waqarzaka.net") ||
                      adminStore?.admin?.admin?.email ==
                        "alex@waqarzaka.net") && (
                      <NavLink
                        className="nav-link sidebar-Link fw-500"
                        to="/admin/send-birthday-wish"
                      >
                        <Cake size={20} />{" "}
                        <span className="ms-3">Send Birthday Wish</span>
                      </NavLink>
                    )}
                  </div>
                </div>
              </li>
            </>
          )}

        {adminStore?.admin?.admin?.email != "stats@waqarzaka.net" &&
          adminType != "livetradestats" && (
            <li className="nav-item my-1">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/template"
              >
                <BookDashed size={20} /> <span className="">ADD TEMPLATE</span>
              </NavLink>
            </li>
          )}
        {adminType == "sackAdmin755" &&
          (adminStore?.admin?.admin?.email == "alex@waqarzaka.net" ||
            adminStore?.admin?.admin?.email == "david@waqarzaka.net" ||
            adminStore?.admin?.admin?.email == "mike@waqarzaka.net") && (
            <>
              <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/user-logs"
                >
                  <UserRoundPen size={20} />{" "}
                  <span className="">SEARCH USER LOGS</span>
                </NavLink>
              </li>
            </>
          )}
        {permissions?.includes("subscryption-data") && (
          <li className="nav-item my-1">
            <NavLink
              className="nav-link sidebar-Link fw-500"
              to="/admin/check-stripe-data"
            >
              <CreditCard size={20} />{" "}
              <span className="">SEARCH STRIPE DETAILS</span>
            </NavLink>
          </li>
        )}
        {permissions?.includes("godzilla") && (
          <li className="nav-item my-1">
            <NavLink
              className="nav-link sidebar-Link fw-500"
              to="/admin/check-godzilla"
            >
              <span className="">SEARCH GODZILLA UID</span>
            </NavLink>
          </li>
        )}
        {permissions?.includes("trade-summary") && (
          <>
            <li className="nav-item my-1">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/create-trade-summary"
              >
                <span className="">Create Trade Summary</span>
              </NavLink>
            </li>
            <li className="nav-item my-1">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/trade-summary"
              >
                <span className="">Trade Summary</span>
              </NavLink>
            </li>
          </>
        )}
        {(permissions?.includes("push-notification") ||
          permissions?.includes("mobile-banner")) && (
          <>
            <li className="nav-item my-1">
              <a
                className="nav-link jc-sb collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#collapseMobile"
                aria-expanded="true"
                aria-controls="collapseMobile"
              >
                <div className="sidebar-dd-label">
                  <IoIosPhonePortrait size={20} /> <span>Mobile App</span>
                </div>
                <i className="fa-solid fa-chevron-down"></i>
              </a>
              <div
                id="collapseMobile"
                className="collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionSidebar"
              >
                <div className="bg-white py-2 collapse-inner rounded">
                  {permissions?.includes("mobile-banner") && (
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/mobile/banner"
                    >
                      <FaImage size={20} />{" "}
                      <span className="ms-3">Home Banner</span>
                    </NavLink>
                  )}
                  {permissions?.includes("push-notification") && (
                    <NavLink
                      className="nav-link sidebar-Link fw-500"
                      to="/admin/mobile/push-notification"
                    >
                      <MdOutlineNotificationsActive size={20} />{" "}
                      <span className="ms-3">Push Notification</span>
                    </NavLink>
                  )}
                  <NavLink
                    className="nav-link sidebar-Link fw-500"
                    to="/admin/mobile/notice"
                  >
                    <MdOutlineNotificationsActive size={20} />{" "}
                    <span className="ms-3">Notice Modal</span>
                  </NavLink>
                </div>
              </div>
            </li>
          </>
        )}

        {adminType == "mackAdmin777" &&
          adminStore?.admin?.admin?.email != "stats@waqarzaka.net" && (
            <>
              <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/consent/users"
                >
                  <FileCheck size={20} />{" "}
                  <span className="">User Consents</span>
                </NavLink>
              </li>
              <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/consent/subscription"
                >
                  <CheckSquare size={20} />{" "}
                  <span className="">Subscription Consents</span>
                </NavLink>
              </li>
              <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/consent/unathorize"
                >
                  <XSquare size={20} />{" "}
                  <span className="">UnAuth Consents</span>
                </NavLink>
              </li>
              <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/member-feedback"
                >
                  <MessageCircle size={20} />{" "}
                  <span className="">Member Feedback</span>
                </NavLink>
              </li>
              <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/blacklist-email"
                >
                  <MailX size={20} /> <span className="">Blacklist Email</span>
                </NavLink>
              </li>
              <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/polls"
                >
                  <Vote size={20} /> <span className="">Polls</span>
                </NavLink>
              </li>
              <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/live-trades"
                >
                  <BarChart2 size={20} /> <span className="">Live Trades</span>
                </NavLink>
              </li>

              {/* <li className="nav-item my-1">
                <NavLink
                  className="nav-link sidebar-Link fw-500"
                  to="/admin/send-push-notification"
                >
                  <span className="">Send Push Notification</span>
                </NavLink>
              </li> */}
            </>
          )}
        {adminType == "livetradestats" && (
          <>
            <li className="nav-item my-1 mt-5">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/live-trading/stats"
              >
                <BarChart2 size={20} /> <span className="">Live Trades</span>
              </NavLink>
            </li>
            <li className="nav-item my-1 my-1">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/live-trading/tradingview"
              >
                <FaChartArea size={20} />{" "}
                <span className="">Tradingview Trades</span>
              </NavLink>
            </li>
          </>
        )}

        {/* Nav Item - Pages Collapse Menu */}
        {/* <li className="nav-item">
              <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                <i className="fas fa-fw fa-cog" />
                <span>Components</span>
              </a>
              <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                <div className="bg-white py-2 collapse-inner rounded">
                  <h6 className="collapse-header">Custom Components:</h6>
                  <a className="collapse-item" href="buttons.html">Buttons</a>
                  <a className="collapse-item" href="cards.html">Cards</a>
                </div>
              </div>
            </li> */}
      </ul>
      {/* End of Sidebar */}
    </>
  );
}
export default Sidebar;
